/* Greenleaf — filters and sort that stay as set, and a live count in the phone's filter sheet.
 * 12 Oct 2026, Andrew's yes, relayed by the Coordinator. Shelves only (collections), never search.
 *
 * Every choice on a shelf is still a real link to Shopify's own filter address, so with this file
 * blocked nothing breaks: each tap reloads the page, as before.
 *
 * 1. REMEMBERED FOR THE VISIT. The filters and the sort order in the address are saved in this
 *    tab's sessionStorage (it is gone when the tab closes). Opening another shelf from anywhere
 *    else (the menu, a card, a link) applies whatever of that exists on the new shelf: a choice
 *    the shelf has no link for is skipped, and nothing is applied if it would leave the shelf empty.
 *    The address is the truth whenever the shopper acts ON a shelf: a shelf opened with filters in
 *    its address saves them; "Clear all", taking a chip off, Back, Forward and Reload (the shopper
 *    arrives from the same shelf, or by history) never re-apply anything. That is what keeps it
 *    from trapping anyone. The chips above the grid always show what is on, with "Clear all".
 *
 * 2. THE PHONE SHEET (900px and under, where the filter column is a bottom sheet). Ticking a choice
 *    does not reload the page: it ticks in place, and after a short pause the section is asked for
 *    its piece count with the new choices (Section Rendering API: the same address plus
 *    section_id), and "Show 24 pieces" updates. Pressing it opens the shelf with those choices;
 *    closing the sheet with its cross drops them. The choices "Your own range" and "Clear all" go
 *    through the same count. Wider than 900px nothing here changes the links.
 */
(function () {
  'use strict';
  var shelf = document.querySelector('.shelf[data-shelf="collection"]');
  if (!shelf || !window.URLSearchParams) return;

  var KEY = 'glShelfPrefs';
  var sid = shelf.getAttribute('data-sid');
  var params = new URLSearchParams(window.location.search);

  function read() { try { return JSON.parse(window.sessionStorage.getItem(KEY)); } catch (e) { return null; } }
  function write(v) {
    try {
      if (v) window.sessionStorage.setItem(KEY, JSON.stringify(v));
      else window.sessionStorage.removeItem(KEY);
    } catch (e) {}
  }
  function filterPairs(p) {
    var out = [];
    p.forEach(function (v, k) { if (k.indexOf('filter.') === 0 && v !== '') out.push([k, v]); });
    return out;
  }
  function sectionUrl(path, pairs, sort) {
    var q = new URLSearchParams();
    pairs.forEach(function (kv) { q.append(kv[0], kv[1]); });
    if (sort) q.set('sort_by', sort);
    return { page: path + (q.toString() ? '?' + q.toString() : ''), section: path + '?' + (q.toString() ? q.toString() + '&' : '') + 'section_id=' + encodeURIComponent(sid) };
  }
  function fetchDoc(url) {
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) { return new DOMParser().parseFromString(html, 'text/html'); });
  }

  /* ---------- 1. remembered for the visit ---------- */
  (function remember() {
    var pairs = filterPairs(params);
    var sort = params.get('sort_by');
    if (pairs.length || sort) { write({ f: pairs, s: sort || '' }); return; }
    if (params.has('page')) return;

    var nav = window.performance && performance.getEntriesByType ? performance.getEntriesByType('navigation')[0] : null;
    var byHistory = nav ? (nav.type === 'back_forward' || nav.type === 'reload') : false;
    var fromHere = false;
    try {
      if (document.referrer) {
        var r = new URL(document.referrer);
        fromHere = r.origin === window.location.origin && r.pathname === window.location.pathname;
      }
    } catch (e) {}
    if (byHistory || fromHere) { write(null); return; }

    var saved = read();
    if (!saved || (!(saved.f && saved.f.length) && !saved.s)) return;

    /* What this shelf can offer: the pair on each choice's link (a shelf with nothing switched on
       links every value with its own pair), and the price boxes for a price range. */
    var have = {};
    var links = shelf.querySelectorAll('.fr a[href]');
    for (var i = 0; i < links.length; i++) {
      try {
        new URL(links[i].href, window.location.href).searchParams.forEach(function (v, k) {
          if (k.indexOf('filter.') === 0) have[k + '\u0001' + v] = true;
        });
      } catch (e) {}
    }
    var keep = [];
    (saved.f || []).forEach(function (kv) {
      var priceBox = shelf.querySelector('.fr input[name="' + kv[0] + '"]');
      if (have[kv[0] + '\u0001' + kv[1]] || priceBox) keep.push(kv);
    });
    var sort = '';
    if (saved.s) {
      var opts = shelf.querySelectorAll('select[name="sort_by"] option');
      for (var o = 0; o < opts.length; o++) if (opts[o].value === saved.s) sort = saved.s;
    }
    if (!keep.length && !sort) return;

    var u = sectionUrl(window.location.pathname, keep, sort);
    /* Never send a shopper to an empty shelf: ask for the section first and go only if it has pieces. */
    fetchDoc(u.section).then(function (doc) {
      if (!doc.querySelector('ul.grid > li.card')) return;
      window.location.replace(u.page + window.location.hash);
    }).catch(function () {});
  })();

  /* ---------- 2. the phone sheet: tick in place, live count ---------- */
  var sheetQuery = window.matchMedia('(max-width:900px)');
  var fr = shelf.querySelector('.fr');
  var go = fr ? fr.querySelector('.fr__go') : null;
  if (!fr || !go) return;
  var clear = fr.querySelector('.fr__clear');
  var path = window.location.pathname;
  var sortNow = params.get('sort_by') || '';
  var start = filterPairs(params);
  var pairs = start.slice();
  var startText = go.textContent;
  var startOn = [];
  var marks = fr.querySelectorAll('a.fr__opt, a.fr__shape, a.fr__chip');
  for (var m = 0; m < marks.length; m++) startOn.push(marks[m].classList.contains('is-on'));

  function key(kv) { return kv[0] + '\u0001' + kv[1]; }
  function has(k, v) { for (var i = 0; i < pairs.length; i++) if (pairs[i][0] === k && pairs[i][1] === v) return true; return false; }
  function drop(k, v) { pairs = pairs.filter(function (kv) { return !(kv[0] === k && (v === undefined || kv[1] === v)); }); }
  function current() { return sectionUrl(path, pairs, sortNow); }
  function dirty() {
    var a = pairs.map(key).sort().join('|'), b = start.map(key).sort().join('|');
    return a !== b;
  }

  function mark(a, on) {
    a.classList.toggle('is-on', on);
    if (on) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current');
    if (a.classList.contains('fr__chip')) {
      var x = a.querySelector('.fr__x2');
      if (on && !x) {
        x = document.createElement('span');
        x.className = 'fr__x2';
        x.setAttribute('aria-hidden', 'true');
        x.innerHTML = '&times;';
        a.appendChild(x);
      } else if (!on && x) a.removeChild(x);
    }
  }
  function paintPrice() {
    var lo = '', hi = '', chips = fr.querySelectorAll('a.fr__chip');
    var names = chips.length ? chips[0].getAttribute('data-pk').split('|') : [];
    for (var i = 0; i < pairs.length; i++) {
      if (pairs[i][0] === names[0]) lo = pairs[i][1];
      if (pairs[i][0] === names[1]) hi = pairs[i][1];
    }
    for (var c = 0; c < chips.length; c++) {
      mark(chips[c], (lo !== '' || hi !== '') && chips[c].getAttribute('data-lo') === lo && chips[c].getAttribute('data-hi') === hi);
    }
  }

  var timer = null, seq = 0, ctrl = null;
  function count() {
    if (clear) clear.hidden = !pairs.length;
    clearTimeout(timer);
    timer = setTimeout(function () {
      var mine = ++seq;
      if (ctrl && ctrl.abort) ctrl.abort();
      ctrl = window.AbortController ? new AbortController() : null;
      fetch(current().section, { credentials: 'same-origin', signal: ctrl ? ctrl.signal : undefined })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          if (mine !== seq) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var n = doc.querySelector('.fr__go');
          if (n && n.textContent.trim()) go.textContent = n.textContent.trim();
        })
        .catch(function () {});
    }, 250);
  }

  function reset() {
    pairs = start.slice();
    clearTimeout(timer); seq++;
    for (var i = 0; i < marks.length; i++) mark(marks[i], startOn[i]);
    go.textContent = startText;
    if (clear) clear.hidden = !start.length;
  }

  function plain(e) { return e.button === 0 && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey; }

  document.addEventListener('click', function (e) {
    if (!sheetQuery.matches || e.defaultPrevented || !plain(e) || !e.target.closest) return;
    var a = e.target.closest('.fr a');
    if (!a || !fr.contains(a)) return;

    if (a.classList.contains('fr__opt') || a.classList.contains('fr__shape')) {
      var k = a.getAttribute('data-k'), v = a.getAttribute('data-v');
      if (!k) return;
      e.preventDefault();
      if (has(k, v)) { drop(k, v); mark(a, false); } else { pairs.push([k, v]); mark(a, true); }
      count();
    } else if (a.classList.contains('fr__chip') && a.getAttribute('data-pk')) {
      e.preventDefault();
      var names = a.getAttribute('data-pk').split('|'), lo = a.getAttribute('data-lo'), hi = a.getAttribute('data-hi');
      var wasOn = a.classList.contains('is-on');
      drop(names[0]); drop(names[1]);
      if (!wasOn) {
        if (lo) pairs.push([names[0], lo]);
        if (hi) pairs.push([names[1], hi]);
      }
      paintPrice();
      count();
    } else if (a.classList.contains('fr__clear')) {
      e.preventDefault();
      pairs = [];
      for (var i = 0; i < marks.length; i++) mark(marks[i], false);
      var boxes = fr.querySelectorAll('.fr__price input');
      for (var b = 0; b < boxes.length; b++) boxes[b].value = '';
      count();
    } else if (a.classList.contains('fr__go')) {
      if (!dirty()) return;
      e.preventDefault();
      window.location.assign(current().page + '#gl-shelf-h');
    }
  });

  /* "Your own range": the Go button sets the price in the same pending list instead of reloading. */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!sheetQuery.matches || !f || !f.classList || !f.classList.contains('fr__price')) return;
    e.preventDefault();
    var inputs = f.querySelectorAll('input[type="number"]');
    for (var i = 0; i < inputs.length; i++) {
      drop(inputs[i].name);
      if (inputs[i].value !== '') pairs.push([inputs[i].name, String(parseInt(inputs[i].value, 10))]);
    }
    paintPrice();
    count();
  });

  /* Closing the sheet with its cross (or Back) drops choices that were not applied. */
  window.addEventListener('hashchange', function () {
    if (window.location.hash !== '#gl-filters' && dirty()) reset();
  });

  /* KEYBOARD ON THE PHONE SHEET (17 Oct 2026 accessibility pass). The sheet opens by its address (#gl-filters),
     so a keyboard user pressing Enter on "Filter" saw it open while focus stayed behind it. Now focus moves to its
     Close, and Escape closes it and puts focus back on "Filter". Phone sheet only; the desktop column is untouched. */
  var opener = document.querySelector('.fr-open'), closer = fr.querySelector('.fr__x');
  var sheetOpen = window.location.hash === '#gl-filters';
  window.addEventListener('hashchange', function () {
    var open = window.location.hash === '#gl-filters', was = sheetOpen;
    sheetOpen = open;
    if (!sheetQuery.matches || !closer) return;
    if (open) closer.focus({ preventScroll: true });
    // Leaving the sheet by its cross or by Escape: the jump to #gl-shelf-h resets focus, so put it back on "Filter".
    else if (was && opener) opener.focus({ preventScroll: true });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' || !sheetQuery.matches || window.location.hash !== '#gl-filters' || !closer) return;
    closer.click();
  });
})();
